import { FC, useEffect, useState } from 'react';
import { useSelector } from '@umijs/max';
import { ConnectState } from '@/models/connect';
import { META_SURCHARGE_NOTICE_PENDING } from '@/utils/constant';
import { isSkippedTour } from '@/utils/config';
import MetaSurchargeModal from './index';

/**
 * 登录后 Meta 广告附加费通知
 * @description
 * 登录成功后会写入 sessionStorage 标记，进入后台首屏时弹出一次，「确认已知悉」后清除标记。
 * 为避免与其它弹窗重叠，需同时满足以下条件才弹出：
 * 1. 新手引导已跳过/已完成（isSkippedTour()），否则轮询等待引导关闭；
 * 2. 已同意最新协议（is_agree），未同意时会强制弹出 AgreeProtocol，需等其关闭。
 */
const MetaSurchargeGlobalNotice: FC = () => {
  // 是否已同意最新协议：未同意时 AgreeProtocol 会强制弹出（不可关闭），需响应式让位
  const { is_agree } = useSelector(
    (state: ConnectState) => state.agreeProtocol,
  );

  // 待弹标记 & 新手引导是否已结束
  const [pending, setPending] = useState(
    () => sessionStorage.getItem(META_SURCHARGE_NOTICE_PENDING) === '1',
  );
  const [tourDone, setTourDone] = useState(() => isSkippedTour());

  useEffect(() => {
    if (!pending || tourDone) {
      return;
    }

    // 存在引导，轮询等待引导关闭后再放行
    const timer = window.setInterval(() => {
      if (isSkippedTour()) {
        window.clearInterval(timer);
        setTourDone(true);
      }
    }, 500);

    return () => window.clearInterval(timer);
  }, [pending, tourDone]);

  const handleClose = () => {
    sessionStorage.removeItem(META_SURCHARGE_NOTICE_PENDING);
    setPending(false);
  };

  // 引导结束、协议已同意、且仍有待弹标记时才展示；协议弹窗在时自动隐藏让位
  return (
    <MetaSurchargeModal
      open={pending && tourDone && is_agree}
      onClose={handleClose}
    />
  );
};

export default MetaSurchargeGlobalNotice;
